import BrowserIsSupported from './BrowserIsSupported'
import MonthCard from './MonthCard'
import ShareAssetModal from './ShareAssetModal'
import ControllerLoader from './ControllerLoader'

N2.ready(() => {
  // $('[data-toggle="tooltip"]').tooltip()
  /** could put this on individual js controllers
   * but a good number of controllers/controller actions
   * currently have no need for js controller
   */
  new N2Styles.pongTabs()

  // use bootstrap select everywhere .form-control is used
  // $("select.form-control").selectpicker()

  if (! new BrowserIsSupported()) {
    new N2Styles.modalOpener('.js-unsupported-browser-modal')
  }

  if (typeof ga !== "undefined"){
    ga("set", "location", location.pathname + location.search)
    ga('send', 'pageview');
  }

  new MonthCard(".month-card")

  N2.handle("click", '.js-history-back', (e) => {
    history.back()
  })

  N2.handle("click", "[data-submit-form]", (e) => {
    e.preventDefault();
    $(this).closest("form").submit();
  })

  N2.handle("click", ".js-history-back", (e) => {
    history.back()
  })

  N2.handle('change', ".fancy-checkbox input[type=checkbox]", (e) => {
    $(".fancy-checkbox .checkbox").toggleClass("active")
  })

  N2.handle('click', ".asset-preview .expanded-menu, .asset-preview .collapsed-menu", (e) => {
    $(".asset-preview .expanded-menu").toggleClass("hidden")
    $(".asset-preview .collapsed-menu").toggleClass("hidden")
  })

  /**
   * Need this atleast for bottom navigation so I've scoped it with .js-bottom-nav
   * so it's not greedy. Active class is not working correctly with two bootstraps
   */

  N2.handle("click", ".js-bottom-nav.nav-item", (evt) => {
    $(evt.currentTarget).parent().find('.nav-item, .nav-link').removeClass('active')
    $(evt.currentTarget).children().addClass('active')
  })


  // Stop the propogation from closing the search bar
  N2.handle("click", '.tt-suggestion', (e) => {
    e.stopPropagation();
  })

  // TODO fix me to use UJS helpers once again after bstrap 3 is gone
  N2.handle("click", "[data-toggle='show']", function(e) {
    $($(this).data('target')).removeClass('hidden');
    $(this).hide();
  });

  N2.handle('click', '#share-asset-modal-link, .js-share-asset-modal', function(e) {
    let data = $(e.currentTarget).data()
    new ShareAssetModal({asset_id: data.asset, expiresAt: data.expiresAt})
  });

  N2.handle('click', '[data-loading=true]', () => {
    N2.showProgressIndicator()
  });

  N2.bindHandler('mouseenter', '.never-wrap', function(e) {
    var $this = $(this);

    if(this.offsetWidth < this.scrollWidth){
      if(!$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    }else{
      $this.removeAttr('title');
    }
  });
})

window.onpopstate = (e) => {
  ControllerLoader.unload(e)
}

// Cleanup the page before making a turbolinks cache image.
$(document).on("turbolinks:before-cache", (e) => {
  // Remove partially-hidden user settings dropdowns.
  $("#sidenav-overlay").remove();
  $('.js-page-loader').remove();
  $("select.selectize").selectize().each((index, selector) => {
    selector.selectize.destroy();
  });
})
